import { api } from '@/services/api'
import { LibraryMapper } from '@/services/mappers/libraryMapper'
import { GeoScoreMapper } from '@/services/mappers/geoScoreMapper'

export class ContentStudioLibraryLoader {
  static async loadAsGeneratedContents(libraryItemId: string): Promise<{
    topic: string
    status: 'draft' | 'published' | 'scheduled'
    platforms: string[]
    currentPlatform: string | null
    generatedContents: Record<string, any>
    activeSkills: string[]
  }> {
    const itemResponse = await api.library.getById(libraryItemId)
    if (!itemResponse.success) {
      throw new Error('Failed to load library item')
    }

    const item = LibraryMapper.toContentItem(itemResponse.data)
    const platforms = Object.keys(item.platforms || {})
    const currentPlatform = platforms[0] || null

    const generatedContents: Record<string, any> = {}

    for (const platform of platforms) {
      const platformData = item.platforms[platform]
      const markdown = platformData?.markdownSource || platformData?.content
      if (!markdown) continue

      const breakdown = (platformData as any)?.geoBreakdown
      if (breakdown) {
        // Use stored LLM-evaluated breakdown (accurate, no need to re-score on load)
        generatedContents[platform] = {
          content: markdown,
          markdownSource: platformData?.markdownSource,
          score: breakdown.total_score,
          checkResults: GeoScoreMapper.toCheckResults(breakdown),
          detectedSkills: breakdown.detected_skills,
          publishedUrl: platformData?.publishedUrl,
        }
      } else {
        // Fallback for older data without breakdown: re-score via API
        const activeSkills = item.activeSkills || []
        const analysis = await api.content.analyzeScore(markdown, platform, activeSkills)
        if (!analysis.success) continue
        generatedContents[platform] = {
          content: markdown,
          markdownSource: platformData?.markdownSource,
          score: analysis.data.total_score,
          checkResults: GeoScoreMapper.toCheckResults(analysis.data),
          detectedSkills: analysis.data.detected_skills,
          publishedUrl: platformData?.publishedUrl,
        }
      }
    }

    return {
      topic: item.title,
      status: item.status,
      platforms,
      currentPlatform,
      generatedContents,
      activeSkills: item.activeSkills || [],
    }
  }
}

